// @ts-nocheck
// fetch submitted estimates data
export const FETCH_ALL_SUBMITTED_ESTIMATES_REQUEST =
  "FETCH_ALL_SUBMITTED_ESTIMATES_REQUEST";
export const FETCH_ALL_SUBMITTED_ESTIMATES_SUCCESS =
  "FETCH_ALL_SUBMITTED_ESTIMATES_SUCCESS";
export const FETCH_ALL_SUBMITTED_ESTIMATES_FAILURE =
  "FETCH_ALL_SUBMITTED_ESTIMATES_FAILURE";

// switch submitted estimate
export const SWITCH_DEPOSIT_INVOICE = "SWITCH_DEPOSIT_INVOICE";

// fetch deposit invoice history
export const FETCH_ALL_DEPOSIT_INVOCIE_REQUEST =
  "FETCH_ALL_DEPOSIT_INVOCIE_REQUEST";
export const FETCH_ALL_DEPOSIT_INVOCIE_SUCCESS =
  "FETCH_ALL_DEPOSIT_INVOCIE_SUCCESS";
export const FETCH_ALL_DEPOSIT_INVOCIE_FAILURE =
  "FETCH_ALL_DEPOSIT_INVOCIE_FAILURE";

// update deposit invoice status
export const CLIENT_DEPOSIT_INVOICE_STATUS_REQUEST =
  "CLIENT_DEPOSIT_INVOICE_STATUS_REQUEST";
export const CLIENT_DEPOSIT_INVOICE_STATUS_SUCCESS =
  "CLIENT_DEPOSIT_INVOICE_STATUS_SUCCESS";
export const CLIENT_DEPOSIT_INVOICE_STATUS_FAILURE =
  "CLIENT_DEPOSIT_INVOICE_STATUS_FAILURE";

// update deposit invoice PO number (finance request 2026-09-10, item 3)
export const DEPOSIT_INVOICE_PO_NUMBER_REQUEST =
  "DEPOSIT_INVOICE_PO_NUMBER_REQUEST";
export const DEPOSIT_INVOICE_PO_NUMBER_SUCCESS =
  "DEPOSIT_INVOICE_PO_NUMBER_SUCCESS";
export const DEPOSIT_INVOICE_PO_NUMBER_FAILURE =
  "DEPOSIT_INVOICE_PO_NUMBER_FAILURE";
